import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;